import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-eth-token",
  "use": "icon-eth-token-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"icon-eth-token\"><rect width=\"40\" height=\"40\" fill=\"#fff\" rx=\"20\" /><path fill=\"#000\" fill-rule=\"evenodd\" d=\"m14.188 20.114 5.961-10.11 5.962 10.11-5.962 2.928-5.962-2.928Zm5.961 9.88-5.962-9.03 5.962 3.288 5.962-3.288-5.962 9.03Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol